export const StepStatus = {
  /** Completed — dot filled, label dimmed. */
  DONE: 'done',
  /** Skipped — dot empty, label dimmed with strikethrough. */
  SKIPPED: 'skipped',
  /** Current location — dot filled with step color, label primary. */
  CURRENT: 'current',
  /** Future step — dot empty gray, label default. */
  NOT_DONE: 'not_done'
} as const;

export type StepStatus = (typeof StepStatus)[keyof typeof StepStatus];
